// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ah-0";
export var optionCard = "_ah-1";